var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"arrow","d":"M3.828,9,9.9,2.929,8.485,1.515,0,10l.707.707,7.778,7.778L9.9,17.071,3.828,11H20V9Z","transform":"translate(18.485) rotate(90)"}));
}

Arrow.defaultProps = {"width":"16.97","height":"20","viewBox":"0 0 16.97 20"};

module.exports = Arrow;

Arrow.default = Arrow;
